import {View, Text} from 'react-native';
import React from 'react';
import ImageHeaderModal from 'ImageHeaderModal';
import {customModalStyles, styles} from './ModalStyles';
import {
  WITHDRAWAL_INFO_MODAL_DEFAULTS,
  WITHDRAWAL_INFO_MODAL_TEST_IDS,
} from '../BankWithdrawalConstants';

type WithdrawalInfoModalProps = {
  onDismiss: () => void;
  onConfirm?: () => void;
  buttonTextPrimary?: string;
  buttonTextSecondary?: string;
  bodyText?: string;
  title?: string;
  hideIcon?: boolean;
};

const WithdrawalInfoModal = ({
  onDismiss,
  onConfirm,
  bodyText,
  title,
  buttonTextPrimary,
  buttonTextSecondary,
  hideIcon,
}: WithdrawalInfoModalProps) => {
  return (
    <ImageHeaderModal
      title={title || WITHDRAWAL_INFO_MODAL_DEFAULTS.title}
      buttonTextPrimary={buttonTextPrimary || WITHDRAWAL_INFO_MODAL_DEFAULTS.buttonTextPrimary}
      imageHeader={hideIcon ? undefined : WITHDRAWAL_INFO_MODAL_DEFAULTS.icon}
      imageWidth={40}
      imageAspectRatio={1}
      backdropShadowEnabled={true}
      onPressPrimary={onConfirm || onDismiss}
      customStyles={customModalStyles}
      testIDs={WITHDRAWAL_INFO_MODAL_TEST_IDS}
      onPressSecondary={onDismiss}
      buttonTextSecondary={buttonTextSecondary || undefined}
    >
      <View>
        <Text style={styles.bodyText} allowFontScaling={false}>
          {bodyText}
        </Text>
      </View>
    </ImageHeaderModal>
  );
};

export default WithdrawalInfoModal;
